<template>
  <div id="app">
    <a class="skip-link" href="#main">Skip to content</a>
    <Menu />
    <main id="main" class="content" tabindex="-1">
      <router-view></router-view>
    </main>
    <Contact/>
    <MGBenefitCalculator/>
    <Footer />
  </div>
</template>

<script>
import Menu from './components/Menu.vue'
import Footer from './components/Footer.vue'
import Contact from './components/Contact.vue'
import MGBenefitCalculator from './components/MGBenefitCalculator.vue';

const DEFAULT_DESC = "The employer-paid financial wellbeing app that gives your team clarity, control and confidence with their money. Nothing to sell, no commission, and member data that never gets shared.";
const DEFAULT_TITLE = "Money Guided. Feel Good Financial Outcomes";
const DEFAULT_IMAGE = "https://moneyguided.com/og-cover.png";

export default {
  name: 'App',
  components: {
    Menu,
    Footer,
    Contact,
    MGBenefitCalculator
  },
  // Site-wide SEO defaults. Each route component overrides these by matching vmid,
  // so vue-meta dedupes to one tag each.
  metaInfo() {
    return {
      meta: [
        { vmid: 'description', name: 'description', content: DEFAULT_DESC },
        { vmid: 'og:type', property: 'og:type', content: 'website' },
        { vmid: 'og:site_name', property: 'og:site_name', content: 'Money Guided' },
        { vmid: 'og:locale', property: 'og:locale', content: 'en_GB' },
        { vmid: 'og:url', property: 'og:url', content: 'https://moneyguided.com' },
        { vmid: 'og:title', property: 'og:title', content: DEFAULT_TITLE },
        { vmid: 'og:description', property: 'og:description', content: DEFAULT_DESC },
        { vmid: 'og:image', property: 'og:image', content: DEFAULT_IMAGE },
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
        { vmid: 'twitter:title', name: 'twitter:title', content: DEFAULT_TITLE },
        { vmid: 'twitter:description', name: 'twitter:description', content: DEFAULT_DESC },
        { vmid: 'twitter:image', name: 'twitter:image', content: DEFAULT_IMAGE },
      ],
    };
  }
}
</script>

<style>

@import './assets/styles/tokens.css';

html, body {
  font-family: 'Montserrat', sans-serif !important;
  overflow-x: clip;
}

#main:focus {
  outline: none;
}

/* Keep the footer below the fold while an async route chunk loads,
   otherwise it paints at the top and jumps (CLS) */
#main {
  min-height: 100vh;
}

.skip-link {
  position: absolute;
  top: -100%;
  left: var(--sp-3);
  z-index: 2000;
  padding: var(--sp-2) var(--sp-4);
  background: var(--mg-ink);
  color: var(--mg-white);
  border-radius: var(--radius-pill);
  font-weight: 700;
}

.skip-link:focus {
  top: var(--sp-3);
  color: var(--mg-white);
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #281C3B;
}

/* Legacy BootstrapVue buttons. Only the deferred employer signup pages and the
   benefit calculator still render .btn elements; scope the old global override
   to them so it can't fight .mg-btn anywhere else. */
#download .btn,
#benefit-modal .btn {
    color: #ffffff !important;
    background-color: #281C3B !important;
    font-size: 11px !important;
    width: 100px !important;
    height: 35px !important;
}

</style>
